import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-sign-up-tos',
    templateUrl: './sign-up-tos.component.html',
    styleUrls: ['./sign-up-tos.component.scss'],
    standalone: false
})
export class SignUpTOSComponent {
  @Output() goNext = new EventEmitter<boolean>();
  @Output() isLoading = new EventEmitter<boolean>();

  goNextFunc() {
    this.goNext.emit(true);
  }
}
